var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.946 3.18a.5.5 0 0 1 .387.487 9.664 9.664 0 0 1-9.666 9.666.5.5 0 0 1-.488-.387l-.5-2.167a.506.506 0 0 1 .292-.575l2.333-1a.5.5 0 0 1 .584.144L6.92 10.61a7.72 7.72 0 0 0 3.692-3.691L9.35 5.886a.5.5 0 0 1-.144-.584l1-2.333a.5.5 0 0 1 .573-.29z"
  })));
};
export default SvgPhone;